

<template>
  <div>
    <div class="b-approve-container__btn b-approve-container__width">
      <div v-if="rejected" class="b-approve-container__rejection--container">
         <!-- <div >
           <div class="b-approve-container__category--text">Select category:</div>
           <select v-model="selectedCategory" class="b-approve-container__select">
               <option
                 v-for="(value,name) in rejectionList"
                 :value="name"
                 :key="name"
                >{{ name}}</option>
            </select>
        </div>
        <div>
           <div class="b-approve-container__category--text">{{selectedCategory==='Others' ? 'Enter' :'Select'}} rejection reason:</div>
           <select v-model="selectedSubCategory" v-if="selectedCategory!=='Others'" multiple  class="b-approve-container__select">
               <option
                 v-for="(item,index) in rejectionList[selectedCategory]"
                 :value="item"
                 :key="index"
                >{{ item }}</option>
            </select>
        </div> -->
        <div v-for="(list,name) in rejectionList" :key="name">
          <div class="b-approve-container__category--text">{{name}}:</div>
          <div v-for="(item,index) in list" :key="index" class="b-approve-container__select--checkbox">
            <input type="checkbox" :id="index" :value="item" v-model="checkedValues">
            <label :for="index">{{item}}</label>
          </div>
          
        </div>
        <div>
           <div class="b-approve-container__category--text">Others:</div>
          <textarea
          rows="5"
          cols="45"
          placeholder="Remarks"
          v-model="reason_for_rejection"
          class="b-approve-container__select"
        ></textarea>
        </div>
        
      </div>

      <div v-if="checkAuthorization()" class="b-personal-container__error">You are not authorized !</div>
      <button
        v-if="details.signature_status =='upload_verification_pending'"
        class="b-global__button"
        @click="submitDetails"
        :disabled="checkAuthorization()"
      >{{rejected ? 'Reject' : 'Approve' }}</button>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
export default {
  data() {
    return {
      picked: "",
      reason_for_rejection: "",
      rejected: false,
      rejectionList:{
        "Verify signature": [
          "Signature is not clear. Please ensure your signature is a close replica of the PAN signature.",
          "Provided signature does not seem a valid one. Please ensure your signature is a close replica of the PAN signature."
      ] 
  },
  selectedCategory:'PAN',
  selectedSubCategory: [],
  checkedValues:[]
    };
  },
  props: {
    tabs: {
      type: Array
    },
    details: {
      type: Object
    },
    isReject: {
      type: Boolean
    }
  },
  mounted() {
    // this.$store.dispatch('fetchPdf', { id: this.$route.params.id, key: 'cvl_form' });
    this.checkApprove();
  },
  methods: {
    submitDetails: function() {
    // console.log(this.checkedValues.concat(this.reason_for_rejection));
    let rejections = this.reason_for_rejection!==""?this.checkedValues.concat(this.reason_for_rejection) : this.checkedValues
    let formattedList =  rejections.map((value,index)=>{
      // console.log(`${index+1}. ${value} \n`);
      return `${index+1}. ${value} \n`
    
    })
    // console.log(formattedList.join(""))
      // let errorMessage= this.selectedCategory==='Others' ? this.reason_for_rejection : this.selectedSubCategory.toString();
      let status = this.rejected ? "rejected" : "approved";
      let remarks = this.rejected ? formattedList.join("") : "";
      this.tabs.map((element, index) => {
        if (index < this.tabs.length - 1) {
          let { name, checkDetails } = element;
          let obj = {};
          name = name.toLowerCase();
          obj[name] = checkDetails;
        }
      });
      let data = { status: status, remarks: remarks };
    // console.log(data.remarks)
      this.$store
        .dispatch("submitSignatureQuery", { id: this.$route.params.id, data })
        .then(() => {
            this.$router.push({ name: 'verify-signature', params: {status: 'Pending', partner: this.admin_partner}});
            this.$store.commit("resetSignatureTab");
          });
    },

    checkAuthorization: function() {
      if (
        this.$store.state.kycLogin.admin &&
        this.$store.state.kycLogin.admin.preferences &&
        this.$store.state.kycLogin.admin.preferences.signature &&
        this.$store.state.kycLogin.admin.preferences.signature.length
      )
        return false;
      else return true;
    },
    checkApprove() {
      let isReject = false;

      for (let i = 0; i <= this.tabs.length - 2; i++) {
        if (this.tabs[i].isReject === true) {
          isReject = true;
          break;
        }
      }
      if (isReject) {
        this.$emit("changeApproveCheckMark", true);
        this.rejected = true;
      } else {
        this.$emit("changeApproveCheckMark", false);
        this.rejected = false;
      }
    }
  },
  computed: {
    ...mapGetters(["getIpvPdfURl"]),
    ...mapState({
      admin_partner: state => state.kycLogin.admin_partner,
      kyc_verification_type: state => state.kycLogin.kyc_verification_type
    }),    
  }
};
</script>

<style scoped>
.b-approve-container__approval {
  margin-top: 30px;
  display: flex;
  justify-content: center;
  min-width: 500px;
}
.b-approve-container__pdf-section {
  display: flex;
  justify-content: center;
  align-items: center;
}
.b-approve-container__width {
  min-width: 500px;
}
.b-approve-container__upload {
  min-width: 500px;
}
.b-approve-container__btn {
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 500px;
}
textarea[placeholder] {
  text-align: center;
}
.b-approve-container__btn-disable {
  margin: 35px !important;
  font-weight: 500;
  font-size: 14px;
  margin: 0;
  padding: 0;
  min-width: 70px;
  padding-left: 25px;
  padding-right: 25px;
  box-sizing: border-box;
  border: none;
  border-radius: 20px;
  box-shadow: 2px 4px 7px 0 #0000001a;
  background-color: #cccccc;
  color: #666666;
  line-height: 3em;
  height: 3em;
  cursor: not-allowed;
}
.b-personal-container__error {
  color: #d8000c;
  margin-top: 15px;
}
.disableLabel {
  color: #888;
}
.b-approve-container__select{
    width: 100%;
    background: white;
    font-size: 16px;
    margin: 16px 0;
    overflow: scroll
}
.b-approve-container__category--text{
  font-weight: 500;
  font-size: 18px;
  padding: 16px 0;
}
.b-approve-container__rejection--container{
  width: 1068px;
}
.b-approve-container__select--checkbox{
  padding: 5px 0;
}
/* .b-approve-container__text-input{
  margin: 16px;
} */
</style>